import React from 'react';

import { useFormDataQuery } from '@/api/getters';
import { Stages } from '@/api/types';
import ClientCardOffer from '@/features/v2/vehicle-damage/components/layout/ClientCardOffer';
import ClientCardVehicleDamage from '@/features/v2/vehicle-damage/components/layout/ClientCardVehicleDamage';

const ClientCardVD = ({
  className,
  isOfferPage,
  isMobileMenu,
}: {
  className?: string;
  isOfferPage?: boolean;
  isMobileMenu?: boolean;
}) => {
  const { data: formData } = useFormDataQuery();
  if (isOfferPage)
    return (
      <ClientCardOffer
        isMobileMenu={isMobileMenu}
        withPdf={
          formData?.stage === Stages.STAGE_IV &&
          !formData?.offer?.offer_rejected
        }
      />
    );

  return <ClientCardVehicleDamage className={className} />;
};

export default ClientCardVD;
